import React, { useState } from 'react';
import {
  AppBar, Toolbar, Button, Box, IconButton,
  Drawer, List, ListItem, ListItemButton, ListItemText, Divider, Typography
} from '@mui/material';
import { Menu as MenuIcon, Close } from '@mui/icons-material';

const APPLY_URL = 'https://cyberwisecorp.com/apply';

const navLinks = [
  { label: 'What You Do', id: 'what-you-do' },
  { label: 'What You Get', id: 'what-you-get' },
  { label: 'Requirements', id: 'requirements' },
  { label: 'Earnings', id: 'earnings' },
  { label: 'FAQ', id: 'faq' },
];

function scrollToSection(id) {
  const el = document.getElementById(id);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleNav = (id) => {
    setMobileOpen(false);
    scrollToSection(id);
  };

  return (
    <>
      <AppBar position="sticky" elevation={0}
        sx={{ background: 'linear-gradient(135deg, #1e3a8a 0%, #7c3aed 100%)' }}>
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <Box component="a" href="https://cyberwisecorp.com" target="_blank" rel="noopener noreferrer"
            sx={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
            <Box component="img" src="/images/cwc-logo-full.png" alt="Cyber Wise Corp"
              sx={{ height: 72, objectFit: 'contain', borderRadius: 1 }} />
          </Box>

          {/* Desktop Nav */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, gap: 0.5, alignItems: 'center' }}>
            {navLinks.map(link => (
              <Button key={link.id} color="inherit" onClick={() => scrollToSection(link.id)}
                sx={{ fontWeight: 500 }}>
                {link.label}
              </Button>
            ))}
          </Box>

          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <Button variant="contained" size="small"
              component="a" href={APPLY_URL} target="_blank" rel="noopener noreferrer"
              sx={{ backgroundColor: '#fbbf24', color: '#1e1e1e', boxShadow: '0 4px 20px rgba(0,0,0,0.4)', border: '2px solid #fbbf24', fontWeight: 600, display: { xs: 'none', sm: 'inline-flex' },
                '&:hover': { backgroundColor: '#f59e0b', boxShadow: '0 6px 25px rgba(0,0,0,0.5)', border: '2px solid #f59e0b' } }}>
              Apply Now
            </Button>

            {/* Mobile menu button */}
            <IconButton color="inherit" onClick={() => setMobileOpen(true)}
              sx={{ display: { md: 'none' } }}>
              <MenuIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer anchor="right" open={mobileOpen} onClose={() => setMobileOpen(false)}>
        <Box sx={{ width: 280, pt: 2 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', px: 2, mb: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>Menu</Typography>
            <IconButton onClick={() => setMobileOpen(false)}><Close /></IconButton>
          </Box>
          <Divider />
          <List>
            {navLinks.map(link => (
              <ListItem key={link.id} disablePadding>
                <ListItemButton onClick={() => handleNav(link.id)}>
                  <ListItemText primary={link.label} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
          <Divider />
          <Box sx={{ p: 2 }}>
            <Button fullWidth variant="contained"
              component="a" href={APPLY_URL} target="_blank" rel="noopener noreferrer"
              sx={{ backgroundColor: '#fbbf24', color: '#1e1e1e', fontWeight: 600,
                '&:hover': { backgroundColor: '#f59e0b' } }}>
              Apply Now
            </Button>
          </Box>
        </Box>
      </Drawer>
    </>
  );
}

export default Header;
